import constants from './constants';
import { createRequest, createSuccess, createFailure } from '../helpers';

export const siteInfoToursRequest = createRequest(constants.siteIntoTours);
export const siteInfoToursSuccess = createSuccess(constants.siteIntoTours);
export const siteInfoToursFailure = createFailure(constants.siteIntoTours);

export const requestSiteInfoTours = siteInfoToursRequest;
